import DisplayInformationDescriptionField from 'components/forms/fields/display-information-field/display-information-supporting-fields/display-information-description-field/display-information-description-field.component';
import DisplayInformationImageUploadField from 'components/forms/fields/display-information-field/display-information-supporting-fields/display-information-image-upload-field/display-information-image-upload-field.component';
import DisplayInformationTitleField from 'components/forms/fields/display-information-field/display-information-supporting-fields/display-information-title-field/display-information-title-field.component';
import { useTranslation } from 'react-i18next';

export type LocationDisplayInfoFieldNames = {
  title: string;
  shortDescription: string;
  longDescription: string;
  smallImage: string;
  mediumImage: string;
};

type LocationDisplayInfoFormType = {
  fieldNames: LocationDisplayInfoFieldNames;
};

const LocationDisplayInfoForm = ({
  fieldNames,
}: LocationDisplayInfoFormType) => {
  const { t } = useTranslation();

  return (
    <>
      <DisplayInformationTitleField
        name={fieldNames.title}
        label={t('forms.locationInfoForm.displayInfo.information.title.label')}
        data-testid="DisplayInformation.Title"
      />
      <DisplayInformationDescriptionField
        name={fieldNames.shortDescription}
        label={t(
          'forms.locationInfoForm.displayInfo.information.shortDescription.label',
        )}
        data-testid="DisplayInformation.ShortDescription"
      />
      <DisplayInformationDescriptionField
        name={fieldNames.longDescription}
        label={t(
          'forms.locationInfoForm.displayInfo.information.longDescription.label',
        )}
        data-testid="DisplayInformation.LongDescription"
      />
      <DisplayInformationImageUploadField
        name={fieldNames.smallImage}
        label={t('forms.locationInfoForm.displayInfo.information.square.label')}
        data-testid="DisplayInformation.SmallImage"
        objectType="STORE"
      />
      <DisplayInformationImageUploadField
        name={fieldNames.mediumImage}
        label={t(
          'forms.locationInfoForm.displayInfo.information.rectangular.label',
        )}
        data-testid="DisplayInformation.MediumImage"
        objectType="STORE"
      />
    </>
  );
};
export default LocationDisplayInfoForm;
